import axios from "axios";

export default {
    read: () => axios.get("/api/menu/read"),
};
